import { useState, useEffect } from 'react'

const NAMES = [
  'Carlos Méndez',
  'Roberto Silva',
  'Juan Pérez',
  'Miguel Torres',
  'Fernando González',
  'Alejandro Ruiz',
  'Diego Morales',
  'Javier Castro',
  'Luis Hernández',
  'Ricardo Vargas',
  'Gabriel Medina',
  'Héctor Salinas',
]

const CITIES = [
  'Buenos Aires',
  'Ciudad de México',
  'Bogotá',
  'Lima',
  'Santiago',
  'Medellín',
  'Córdoba',
  'Guadalajara',
  'Monterrey',
  'Cali',
  'Quito',
  'Caracas',
  'Asunción',
  'Montevideo',
  'Rosario',
]

export const usePurchaseNotifications = () => {
  const [notification, setNotification] = useState<{
    name: string
    city: string
  } | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const showRandomNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)]
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)]

      setNotification({ name: randomName, city: randomCity })
      setIsVisible(true)

      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false)
      }, 5000)
    }

    // Initial delay
    const initialTimeout = setTimeout(showRandomNotification, 5000)

    // Loop every 8-15 seconds
    const interval = setInterval(() => {
      const randomDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000)
      setTimeout(showRandomNotification, randomDelay)
    }, 15000)

    return () => {
      clearTimeout(initialTimeout)
      clearInterval(interval)
    }
  }, [])

  return { notification, isVisible }
}
